export default __webpack_public_path__ + "static/media/rotary.71f056ec.png";